// import { PRODUCT_TYPE } from '@constants';
import { PRODUCT_NAME } from '@/constants';
import {
  CoveragePeriodCell,
  CoveredValueCell,
  OrderIdCell,
  PolicyIdCell,
  StatusCell,
  NormalCell,
  PremiumCell,
} from './ListItem';

/** sessionStorage 缓存列表数据的 key，目的：从 policy detail 页面返回时记录列表状态 */
export const SESSION_KEY = {
  POLICY_LIST: 'SEEL_POLICY_LIST',
  POLICY_LIST_TABINDEX: 'SEEL_POLICY_LIST_TABINDEX',
  POLICY_SEARCHVALUE: 'SEEL_POLICY_SEARCHVALUE',
};
export const policyTypeToProductNameMap = {
  ra: PRODUCT_NAME.RETURN_ASSURANCE,
  bp: PRODUCT_NAME.GREEN_SHIPPING_PROTECTION,
  as: PRODUCT_NAME.ASSURED_SALE,
  ew: PRODUCT_NAME.EXTENDED_WARRANTY,
};
// policy list 返回的是policy Type，需要转换为productName展示
export const getProductName = (type, isShopify) => {
  if (isShopify) {
    return PRODUCT_NAME.DELIVERY_GUARANTEE;
  }
  return policyTypeToProductNameMap[type];
};

const PolicyCellConfig = {
  Policy: (minWidth) => ({
    id: 'policyId',
    label: 'Cover ID',
    minWidth,
    align: 'left',
    format: PolicyIdCell,
  }),
  Status: (minWidth) => ({
    id: 'status',
    label: 'Status',
    minWidth,
    align: 'left',
    format: StatusCell,
  }),
  // CoverIDCell: (minWidth) => ({
  //   id: 'policyId',
  //   label: 'Cover ID',
  //   minWidth,
  //   align: 'left',
  //   format: NormalCell,
  // }),
  OrderName: (minWidth) => ({
    id: 'orderName',
    label: 'Order Number',
    minWidth,
    align: 'left',
    format: OrderIdCell,
  }),
  // OrderNumber: (minWidth) => ({
  //   id: 'orderNumber',
  //   label: 'Order Number',
  //   minWidth,
  //   align: 'left',
  //   format: OrderIdCell,
  // }),
  CoveragePeriod: (minWidth) => ({
    id: 'policyCreateDate',
    label: 'Created At',
    minWidth,
    align: 'left',
    format: CoveragePeriodCell,
  }),
  // Coverage: (minWidth) => ({ // 保单数量
  //   id: 'coverageItemsNum',
  //   label: 'Coverage',
  //   minWidth,
  //   align: 'left',
  //   format: CoverageCell,
  // }),
  CoveredValue: (minWidth) => ({ // 保单金额
    id: 'sumAssured',
    label: 'Protected Value',
    minWidth,
    align: 'right',
    format: CoveredValueCell,
  }),
  // CreatedAt: (minWidth) => ({ // 创建时间
  //   id: 'policyCreateDate',
  //   label: 'Created At',
  //   minWidth,
  //   align: 'left',
  //   format: CoveragePeriodCell,
  // }),
  // Customer: (minWidth) => ({
  //   id: 'customerName',
  //   label: 'Customer',
  //   minWidth,
  //   align: 'left',
  //   format: NormalCell,
  // }),
  // ProtectedValue: (minWidth) => ({
  //   id: 'sumAssured',
  //   label: 'Protected Value',
  //   minWidth,
  //   align: 'right',
  //   format: CoveredValueCell,
  // }),
  // ProtectionCost: (minWidth) => ({
  //   id: 'premium',
  //   label: 'Protection Cost',
  //   minWidth,
  //   align: 'right',
  //   format: CoveredValueCell,
  // }),
  ProductName: (minWidth) => ({ // 产品名称
    id: 'productName',
    label: 'Product',
    minWidth,
    align: 'left',
    format: NormalCell,
  }),
  AssuranceAmount: (minWidth) => ({ // 保额
    id: 'premium',
    label: 'Protection Cost',
    minWidth,
    align: 'right',
    format: PremiumCell,
  }),
};

/**
 * policy list 的 column 配置
 */
// export const POLICY_COLUMNS = {
//   // all
//   all: [
//     PolicyCellConfig.Policy(130),
//     PolicyCellConfig.CoveragePeriod(180),
//     PolicyCellConfig.OrderName(130),
//     PolicyCellConfig.Status(80),
//     PolicyCellConfig.Coverage(80),
//     PolicyCellConfig.CoveredValue(80),
//   ],
//   // Return Assurance
//   [PRODUCT_TYPE.Return]: [
//     PolicyCellConfig.Policy(130),
//     PolicyCellConfig.CoveragePeriod(180),
//     PolicyCellConfig.OrderName(130),
//     PolicyCellConfig.Status(80),
//     PolicyCellConfig.Coverage(80),
//     PolicyCellConfig.CoveredValue(80),
//   ],
//   // Buyer Protection
//   [PRODUCT_TYPE.Buyer]: [
//     PolicyCellConfig.Policy(130),
//     PolicyCellConfig.CoveragePeriod(180),
//     PolicyCellConfig.OrderName(130),
//     PolicyCellConfig.Status(80),
//     PolicyCellConfig.Coverage(80),
//     PolicyCellConfig.CoveredValue(80),
//   ],
//   // Shipping Protection
//   [PRODUCT_TYPE.Assured]: [
//     PolicyCellConfig.Policy(130),
//     PolicyCellConfig.CoveragePeriod(180),
//     PolicyCellConfig.OrderName(130),
//     PolicyCellConfig.Status(80),
//     PolicyCellConfig.Coverage(80),
//     PolicyCellConfig.CoveredValue(80),
//   ],
// };
// 字段已经统一
export const POLICY_COLUMNS = [
  PolicyCellConfig.ProductName(130),
  PolicyCellConfig.Policy(130),
  PolicyCellConfig.CoveragePeriod(180),
  PolicyCellConfig.OrderName(130),
  PolicyCellConfig.Status(80),
  PolicyCellConfig.CoveredValue(80),
  PolicyCellConfig.AssuranceAmount(80),

];

// 特殊店铺集合 针对特殊shopify店铺，policy list不做筛选。起因后端数据新老不兼容
export const SPECIAL_MERCHANTS = ['seel-dev-store.myshopify.com', 'mooncool-2.myshopify.com', 'shoppremiumoutlets.myshopify.com', 'sspotest.myshopify.com', 'curtsyapp.com', 'goodwillfinds.com', 'shopshops.com'];
